//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/DesignSimulation.js";
import "../no/NXObject.js";
import "../DesignSimulation/DesignSimulation.AnalysisBodyResults.js";
let d=[[[0,"Body",0,"Body",0],[0,"IsBlanked",0,0],[0,"Material",0,"Material",0],[0,"ReferencedBodyName",0,0],[1,"Results",0,"DesignSimulation.AnalysisBodyResults",0]],[[[],"Blank",{},0,0],[[],"Unblank",{},0,0],[["massValue","massUnit"],"GetMass",{},0,0]],[]];
SPLM.DesignSimulation.AnalysisBody = class extends SPLM.NXObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.DesignSimulation.AnalysisBody";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;